import * as React from 'react';

const IcCar = props => (
  <svg width={97} height={96} xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{'065675F8-878A-48DA-BF1F-E5B3AB8EE94C'}</title>
    <defs>
      <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="a">
        <stop stopColor="#E64E40" offset="0%" />
        <stop stopColor="#E6457A" offset="100%" />
      </linearGradient>
    </defs>
    <g transform="translate(.5)" fill="none" fillRule="evenodd">
      <rect fill="url(#a)" width={96} height={96} rx={48} />
      <g fillRule="nonzero">
        <path
          d="M80.615 57.186V50.36a4.65 4.65 0 0 0-4.171-4.618l-17.96-1.884L53.9 33.809a4.66 4.66 0 0 0-4.242-2.722H27.407a4.662 4.662 0 0 0-4.045 2.34l-7.978 13.912a2.326 2.326 0 0 0-2.33 2.322v7.526h67.561Z"
          fill="#3BCD92"
        />
        <path
          d="m76.444 45.74-17.96-1.884L53.9 33.808a4.66 4.66 0 0 0-4.242-2.722h-2.803a4.66 4.66 0 0 1 4.242 2.722l4.583 10.048 17.96 1.885a4.65 4.65 0 0 1 4.171 4.618v6.827h2.803V50.36a4.65 4.65 0 0 0-4.171-4.618Z"
          fill="#36A882"
        />
        <path
          d="M13.055 60.429v-3.803h69.047c.466 0 .843.377.843.841v2.962c0 .464-.377.84-.843.84H13.899a.842.842 0 0 1-.844-.84Z"
          fill="#FEB756"
        />
        <path
          d="m29.363 43.856.025 3.811a.842.842 0 0 0 .783.863c5.425.411 9.675 4.918 9.675 10.418v2.322h14.311V44.697a.842.842 0 0 0-.844-.84h-23.95Z"
          fill="#36A882"
        />
        <path
          d="M39.846 61.27h14.311v-4.644H39.583c.17.747.263 1.524.263 2.322v2.322Z"
          fill="#FA8043"
        />
        <g transform="translate(22.266 51.864)" fill="#57555C">
          <ellipse cx={7.097} cy={7.085} rx={6.989} ry={6.965} />
          <ellipse cx={44.373} cy={7.085} rx={6.989} ry={6.965} />
        </g>
        <g transform="translate(25.781 55.367)" fill="#85828C">
          <ellipse cx={3.582} cy={3.581} rx={3.494} ry={3.483} />
          <ellipse cx={40.856} cy={3.581} rx={3.494} ry={3.483} />
        </g>
        <path
          d="M13.055 53.725h3.816a.842.842 0 0 0 .843-.841v-1.802a.842.842 0 0 0-.843-.84h-3.816v3.483Z"
          fill="#FD3A4E"
        />
        <path
          d="M82.102 56.626h-2.813c.466 0 .844.377.844.841v2.962c0 .464-.378.84-.844.84h2.813a.842.842 0 0 0 .843-.84v-2.962a.842.842 0 0 0-.843-.84Z"
          fill="#FA8043"
        />
        <path
          d="M16.87 50.241h-2.812c.466 0 .844.377.844.841v1.802c0 .464-.378.84-.844.84h2.813a.842.842 0 0 0 .843-.84v-1.802a.842.842 0 0 0-.843-.84Z"
          fill="#DE0B2B"
        />
        <path
          d="M80.616 50.359c0-.237-.02-.47-.054-.699H76.8a.842.842 0 0 0-.843.841v1.802c0 .464.377.84.843.84h3.816V50.36Z"
          fill="#FEB756"
        />
        <path
          d="M80.562 49.66H77.75c.034.229.053.462.053.699v2.785h2.813v-2.785c0-.237-.02-.47-.054-.699Z"
          fill="#FA8043"
        />
        <g fill="#4B494F">
          <path d="M66.638 51.983c-.482 0-.952.048-1.407.14 3.186.65 5.583 3.458 5.583 6.825s-2.397 6.176-5.583 6.824c.455.093.925.142 1.407.142 3.86 0 6.989-3.119 6.989-6.966s-3.13-6.965-6.99-6.965ZM29.363 51.983c-.482 0-.952.048-1.406.14 3.186.65 5.582 3.458 5.582 6.825s-2.396 6.176-5.582 6.824c.454.093.924.142 1.406.142 3.86 0 6.989-3.119 6.989-6.966s-3.13-6.965-6.989-6.965Z" />
        </g>
        <g fill="#C0E3F0">
          <path d="M22.706 34.57h2.873a.841.841 0 0 1 .733 1.257l-4.36 7.606a.844.844 0 0 1-.733.423h-3.837l5.324-9.287ZM54.248 34.57h-2.66a.841.841 0 0 0-.78 1.16l3.134 7.605c.13.315.439.521.78.521h3.762l-4.236-9.287ZM49.02 42.696l-3.135-7.605a.844.844 0 0 0-.78-.522H32.847a.845.845 0 0 0-.733.424l-4.36 7.605a.841.841 0 0 0 .733 1.258h19.752c.6 0 1.008-.606.78-1.16Z" />
        </g>
        <g fill="#A3CFE3">
          <path d="m56.64 39.814-2.392-5.245h-2.66a.856.856 0 0 0-.137.013l4.23 9.274h2.803l-1.844-4.042ZM49.02 42.696l-3.135-7.605a.844.844 0 0 0-.78-.522h-2.813c.342 0 .65.206.78.522l3.135 7.605a.841.841 0 0 1-.78 1.16h2.812c.6 0 1.008-.606.78-1.16Z" />
        </g>
        <path
          d="M29.363 54.414c-2.508 0-4.55 2.034-4.55 4.534s2.042 4.534 4.55 4.534 4.549-2.034 4.549-4.534-2.04-4.534-4.549-4.534Zm0 6.966a2.438 2.438 0 0 1-2.44-2.432 2.438 2.438 0 0 1 2.44-2.431c1.345 0 2.44 1.09 2.44 2.431a2.438 2.438 0 0 1-2.44 2.432Z"
          fill="#000"
        />
        <path
          d="M29.363 57.316c-.582 0-1.055.47-1.055 1.051v1.161c0 .58.473 1.051 1.055 1.051s1.055-.47 1.055-1.05v-1.162c0-.58-.473-1.051-1.055-1.051ZM66.638 54.414c-2.509 0-4.55 2.034-4.55 4.534s2.041 4.534 4.55 4.534c2.508 0 4.549-2.034 4.549-4.534s-2.041-4.534-4.55-4.534Zm0 6.966a2.438 2.438 0 0 1-2.44-2.432 2.438 2.438 0 0 1 2.44-2.431c1.345 0 2.44 1.09 2.44 2.431a2.438 2.438 0 0 1-2.44 2.432Z"
          fill="#000"
        />
        <path
          d="M66.638 57.316c-.583 0-1.055.47-1.055 1.051v1.161c0 .58.472 1.051 1.055 1.051.582 0 1.054-.47 1.054-1.05v-1.162c0-.58-.472-1.051-1.054-1.051Z"
          fill="#000"
        />
        <path
          d="M82.945 55.575H81.67V50.359a5.69 5.69 0 0 0-5.116-5.664l-17.36-1.821-4.333-9.5a5.727 5.727 0 0 0-5.202-3.339H35.801c-.583 0-1.055.47-1.055 1.051s.472 1.052 1.055 1.052h13.858c1.121 0 2.164.523 2.838 1.38H50.33c-.352 0-.68.175-.876.466-.196.291-.233.66-.1.985l3.748 9.095v11.51h-12.71c-1.35-4.377-5.255-7.65-9.974-8.078v-2.589h19.08c.351 0 .68-.174.875-.466.196-.29.234-.66.1-.984l-3.827-9.287a1.055 1.055 0 0 0-.976-.652H32.357c-.378 0-.728.202-.916.53l-5.324 9.287c-.187.325-.185.725.003 1.049.19.324.537.523.913.523h1.275V48.5c0 .58.472 1.05 1.055 1.05a9.442 9.442 0 0 1 8.798 6.024h-1.504a8.055 8.055 0 0 0-7.294-4.643 8.054 8.054 0 0 0-7.294 4.644h-7.96v-.8h3.605c.583 0 1.055-.47 1.055-1.05V50.24c0-.58-.472-1.051-1.055-1.051h-3.513a1.276 1.276 0 0 1 1.181-.8H24.703c.583 0 1.055-.47 1.055-1.051 0-.58-.472-1.051-1.055-1.051h-7.501l.791-1.38h3.715c.379 0 .728-.203.916-.53l5.325-9.288a1.048 1.048 0 0 0-.004-1.049 1.055 1.055 0 0 0-.912-.523h-2.465a3.617 3.617 0 0 1 2.84-1.38h4.455c.583 0 1.055-.471 1.055-1.052 0-.58-.472-1.05-1.055-1.05h-4.456a5.73 5.73 0 0 0-4.961 2.868l-7.71 13.446A3.382 3.382 0 0 0 12 49.661V61.27c0 .58.473 1.05 1.055 1.05h9.013a8.055 8.055 0 0 0 7.295 4.645 8.055 8.055 0 0 0 7.294-4.644h22.686a8.055 8.055 0 0 0 7.294 4.644 8.054 8.054 0 0 0 7.295-4.644h9.013c.583 0 1.055-.47 1.055-1.051v-4.644c0-.58-.472-1.051-1.055-1.051ZM32.97 35.62h11.994l2.961 7.185H28.85l4.12-7.185Zm46.592 16.472h-2.55v-1.38h2.55v1.38ZM53.569 35.62l3.277 7.185h-1.982l-2.96-7.185h1.665Zm1.643 9.288h3.216l17.905 1.878a3.597 3.597 0 0 1 2.774 1.823h-3.15a1.056 1.056 0 0 0-1.055 1.051v3.484c0 .58.472 1.05 1.054 1.05h3.605v1.381h-5.629a8.054 8.054 0 0 0-7.294-4.643 8.055 8.055 0 0 0-7.295 4.643h-4.131V44.908Zm-2.11 12.769v2.542H40.901v-1.27c0-.43-.026-.854-.073-1.272h12.274ZM16.66 52.673h-2.55v-1.38h2.55v1.38Zm4.436-9.868H19.2l4.12-7.185h1.897l-4.12 7.185ZM14.11 60.218v-2.54h7.311a8.007 8.007 0 0 0 0 2.54H14.11Zm15.253 4.644c-3.272 0-5.934-2.653-5.934-5.914 0-3.261 2.662-5.914 5.934-5.914 3.272 0 5.934 2.653 5.934 5.914 0 3.261-2.662 5.914-5.934 5.914Zm7.941-7.185h1.399c.057.416.089.84.089 1.271v1.27h-1.488a8.002 8.002 0 0 0 0-2.541Zm17.908 2.542v-2.542h3.484a8.011 8.011 0 0 0 0 2.542h-3.484Zm11.426 4.643c-3.273 0-5.935-2.653-5.935-5.914 0-3.261 2.663-5.914 5.935-5.914s5.934 2.653 5.934 5.914c0 3.261-2.662 5.914-5.934 5.914Zm15.253-4.644h-7.312a8.019 8.019 0 0 0 0-2.54h7.312v2.54Z"
          fill="#000"
        />
        <path
          d="M41.01 48.61c-.582 0-1.054.47-1.054 1.051 0 .58.472 1.051 1.055 1.051h2.33c.582 0 1.054-.47 1.054-1.051 0-.58-.472-1.051-1.054-1.051h-2.33Z"
          fill="#000"
        />
      </g>
    </g>
  </svg>
);

export default IcCar;
